import { render } from "./AddOrganisationDailyReportHeader.vue?vue&type=template&id=5ea321f2"
import script from "./AddOrganisationDailyReportHeader.vue?vue&type=script&lang=js"
export * from "./AddOrganisationDailyReportHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__